import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=931be2a4&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=ts&"
export * from "./Comment.vue?vue&type=script&lang=ts&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=931be2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931be2a4",
  null
  
)

export default component.exports